/**
 * A set of generalised, player-agnostic errors which are dispatched from the attached solution.
 */
import { enumeration } from '@dazn/peng-html5-tools-utils';
var SolutionErrorType = enumeration([
    'CDM_ERROR',
    'CERTIFICATE_REQUEST_FAILED',
    'FATAL_EXCEPTION',
    'FORMAT_UNSUPPORTED',
    'KEY_SYSTEM_UNSUPPORTED',
    'LICENSE_EXPIRED',
    'LICENSE_REQUEST_FAILED',
    'MANIFEST_REQUEST_FAILED',
    'MEDIA_DECODE_ERROR',
    'SEGMENT_REQUEST_FAILED',
    'UNEXPECTED_STALL',
]);
export { SolutionErrorType };
//# sourceMappingURL=SolutionErrorType.js.map